import Modal from 'react-responsive-modal';
import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

class InstallationServiceShipmentModal extends React.Component {
  render() {
    const {
      translate,
      shipmentModalOpen,
      closeShipmentDataModal,
      onEmptyFieldsAndFetchShipmentData,
      shipmentNumber,
    } = this.props;

    const modalStyles = {
      modal: {
        borderRadius: '3px',
        padding: '2rem',
        maxHeight: '90vh',
      },
    };

    return (
      <div className="container">
        <Modal
          open={shipmentModalOpen}
          onClose={closeShipmentDataModal}
          little
          showCloseIcon
          styles={modalStyles}>
          <div className="row">
            <div className="col-sm-2">
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={closeShipmentDataModal} />
            </div>
          </div>
          <div className="row modal-text">
            <h4 className="text-align-center">
              {translate('service_installation.shipment_modal_prefill_override_text')}
            </h4>
          </div>
          <div>
            <div className="col-sm-2">
              <button
                onClick={closeShipmentDataModal}
                type="button"
                className="button-background-color-cancel form-button-small
                        form-input-shadow">
                {translate('form.reset')}
              </button>
            </div>
            <div className="col-sm-2 col-md-offset-4">
              <button
                onClick={() => onEmptyFieldsAndFetchShipmentData(shipmentNumber)}
                type="button"
                className="form-button-small form-input-shadow">
                {translate('form.submit')}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceShipmentModal);



// WEBPACK FOOTER //
// ./src/views/InstallationServiceShipmentModal.js